export const FETCH_IMPORTS = '/import-jobs/getall';